import { Grid, MenuItem, Checkbox, ListItemText, Typography } from '@material-ui/core';
import FancySelectButton from './FancySelectButton';

import FilterDropdown from '../atom/FilterDropdown';
/**
 * Use the same datastructure here as we would in PriceRuleSelect
 * [{id:..., name:....},....]
 */

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 224,
            width: 'auto'
        }
    },
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'left'
    },
    transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
    },
    getContentAnchorEl: null
};

function FancyButtongroupMultiSelect({
    options,
    value,
    setValue,
    label,
    maxVisibleItems = 4,
    single = false
}) {
    // Ensure value is always an array
    const safeValue = Array.isArray(value) ? value : [];

    return (
        <>
            {options.length > maxVisibleItems ? (
                <FilterDropdown
                    label={label}
                    key={'fancy-select-dropdown'}
                    options={options}
                    value={
                        single
                            ? options
                                  .map(opt => String(opt.id))
                                  .find(id => safeValue.includes(id)) || ''
                            : options
                                  .map(opt => String(opt.id))
                                  .filter(id => safeValue.includes(id))
                    }
                    setValue={value => {
                        if (single) {
                            setValue(value ? [value] : []);
                            return;
                        }
                        const selectedFromRemaining = Array.isArray(value) ? value : [];
                        setValue(selectedFromRemaining);
                    }}
                    SelectProps={{
                        MenuProps,
                        multiple: !single,
                        displayEmpty: true,
                        renderValue: selected => {
                            const selectedIds = single ? [String(selected)] : selected.map(String);
                            const activeOptions = options
                                .filter(option => selectedIds.includes(String(option.id)))
                                .map(option => option.name);
                            return (
                                <Typography variant="inherit">
                                    {activeOptions.length > 0
                                        ? activeOptions.join(', ')
                                        : 'Select options'}
                                </Typography>
                            );
                        }
                    }}
                >
                    {options.map(option => (
                        <MenuItem key={option.id} value={String(option.id)}>
                            {!single && (
                                <Checkbox checked={safeValue.includes(String(option.id))} />
                            )}
                            <ListItemText primary={option.name} />
                        </MenuItem>
                    ))}
                </FilterDropdown>
            ) : (
                <Grid item container className="golf-options" justifyContent="flex-start">
                    <Grid item container spacing={1}>
                        {options.map((val, index) => {
                            const idString = val.id.toString();
                            return (
                                <Grid
                                    key={idString}
                                    item
                                    xs={6}
                                    container
                                    justifyContent={index % 2 === 0 ? 'flex-end' : 'flex-start'}
                                    alignItems="center"
                                >
                                    <Grid item>
                                        {index <= 1 && <p>{index === 0 ? label : '\u00a0'}</p>}
                                        <FancySelectButton
                                            highlight={
                                                single
                                                    ? idString === safeValue[0]
                                                    : safeValue.includes(idString)
                                            }
                                            onClick={() => {
                                                if (single) {
                                                    setValue([idString]);
                                                    return;
                                                }
                                                if (safeValue.includes(idString)) {
                                                    setValue(safeValue.filter(e => e !== idString));
                                                } else {
                                                    setValue([...safeValue, idString]);
                                                }
                                            }}
                                            label={val.name}
                                        />
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
            )}
        </>
    );
}

export default FancyButtongroupMultiSelect;
